<template>
<div>
  <modal v-model="show"
         @hide="$emit('input', false)"
         :header="false"
         :footer="false">
    <div v-if="show">
      <h3>
        {{ user.firstName }} {{ user.name }}<br/>
        <small><i>{{ user.id }}</i></small><br/>
        <small>Emails : {{ user.email }}</small><br/>
        <small>Roles : {{ user.roles }}</small><br/>
        <small>Dernière connexion :
          {{ displayDate(user.lastLogin, "Aucune connexion") }}</small><br/>
        <div v-if="showPwdInfo">
          <small>Expiration du changement de mot de passe :
            {{ displayDate(user.pwdResetDate, '') }}</small><br/>
          <small>Identifiant du changement de mot de passe :
            {{ user.pwdResetTkn }}</small>
        </div>
      </h3>
      <div class="panel panel-default"
           v-for="(l, k) in userDetails"
           :key="k">
        <div class="panel-body">
          <div v-for="(u, v, i) in l"
               :key="`${k}-${i}`">
            <strong>{{ v }} :</strong> {{ u }}
          </div>
        </div>
      </div>
    </div>
  </modal>
</div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'user-modal',

  props: {
    user: {
      type: Object
    },

    value: {
      type: Boolean,
      required: true
    },

    storePrefix: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      show: false,
      target: null
    }
  },

  computed: {
    userDetails: function () {
      if (this.target == null) {
        return null
      }

      return this.$store.getters[`${this.storePrefix}/info`](this.target.id)
    },

    showPwdInfo () {
      return this.target != null && this.target.pwdResetTkn != null
    }
  },

  methods: {
    getUserInfo: function (u) {
      const instance = this
      this.$store.dispatch(`${this.storePrefix}/info`, u.id).then(
        (response) => {
          if (response.data.err == null) {
            instance.target = u
            instance.show = true
          } else {
            instance.$notify({
              type: 'danger',
              title: 'Erreur !',
              duration: 0,
              content: `Impossible de récupérer les informations de
              l'utilisateur ${u.email}: ${response.data.err}.`
            })
          }
          return response
        }
      ).catch(
        function (e) {
          instance.$notify({
            type: 'danger',
            title: 'Erreur !',
            duration: 0,
            content: `Impossible de récupérer les informations de
              l'utilisateur ${u.email}: ${e.data}.`
          })
        }
      )
    },

    displayDate: function (d, msg) {
      let dt = new Date(d)
      if (dt.getFullYear() !== 1) {
        return moment(dt).format('DD/MM/YYYY HH:mm')
      }
      return msg
    }
  },

  watch: {
    value (value) {
      if (value) {
        this.getUserInfo(this.user)
      }
    }
  }
}
</script>

<style scoped lang="less">
</style>
